import "./NewReleases.scss";

import NewReleasesPage from "./NewReleases";

export default NewReleasesPage;
